import _ from 'lodash';

import { bindServices } from '@/services/api';
import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';

const api = bindServices('aiBillingCredits');

const namespace = 'aiBillingCredits';
const fetchRoute = 'billing/ai/credits';
const fetchParams = 'AiBillingCredit';

const initialPagination = { page: 1, count: 0, totalPages: 0 };

const initialState = {
  list: [],
  listLoaded: false,
  pagination: initialPagination,
  orderBy: '',
  select: CoreQueries[fetchParams].paged.select,
};

const AiBillingCreditsModel = {
  namespace,
  state: initialState,

  effects: {
    *fetchList({ payload }, { call, put, select }) {
      try {
        const pageSize = yield select((state) => state.global.pageSize);
        const params = {
          ...CoreQueries[fetchParams].paged,
          pageSize,
          ...payload,
        };
        const res = yield call(api.getAll, {
          route: `${fetchRoute}/paged`,
          params,
          readPriority: true,
        });
        yield put({
          type: 'queryData',
          payload: { ...res, limit: payload.limit ?? pageSize, page: payload.page ?? 1 },
        });
      } catch (e) {
        /*  */
      }
    },

    *setOrderBy({ payload }, { put }) {
      yield put({ type: 'queryOrderBy', payload });
    },

    *resetState(_, { put }) {
      yield put({ type: 'reset' });
    },
  },

  reducers: {
    queryData(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        listLoaded: true,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    queryOrderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    reset() {
      return { ...initialState, pagination: { ...initialPagination } };
    },
  },
};

export default AiBillingCreditsModel;
